// tslint:disable
/**
 * Selfcare Client API
 * Web API for Visio Selfcare Client
 *
 * The version of the OpenAPI document: v1
 * Contact: harju.oskarinen@dataprisma.fi
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * Contains information about a single calender date
 * @export
 * @interface CalendarProductDayDto
 */
export interface CalendarProductDayDto {
    /**
     * Days is selected and service is active.
     * @type {boolean}
     * @memberof CalendarProductDayDto
     */
    isSelected: boolean;
    /**
     * When day is locked user cannot make modifications to it in application. Client displays locked days as disabled.
     * @type {boolean}
     * @memberof CalendarProductDayDto
     */
    isLocked: boolean;
    /**
     * id is used to ensure day is not mixed with another due to scuffed date-to-date comparision
     * @type {number}
     * @memberof CalendarProductDayDto
     */
    id: number;
    /**
     * Actual Date. Is transported as ISO-8601 date string over api (Automatic json-conversion)
     * @type {string}
     * @memberof CalendarProductDayDto
     */
    date: string;
    /**
     * Date in YYYY-MM-DD string format. Used to ensure timezones don\'t cause issues
     * @type {string}
     * @memberof CalendarProductDayDto
     */
    dateString: string;
}
/**
 * 
 * @export
 * @interface CalendarProductDto
 */
export interface CalendarProductDto {
    /**
     * Product displayname, shown to customers
     * @type {string}
     * @memberof CalendarProductDto
     */
    name: string;
    /**
     * Product description for end customers, shown to customers.
     * @type {string}
     * @memberof CalendarProductDto
     */
    description: string;
    /**
     * Calendar selection description text shown to customers.
     * @type {string}
     * @memberof CalendarProductDto
     */
    selfCareDescription: string;
    /**
     * Calender year where product is in effect
     * @type {number}
     * @memberof CalendarProductDto
     */
    year: number;
    /**
     * Indicates how user selects days in browser. Supported types are \"day\" and \"continuous\"
     * @type {SelectionTypeEnum}
     * @memberof CalendarProductDto
     */
    selectionType: SelectionTypeEnum;
    /**
     * Max allowed selections made by user, whether this means days or months depends on SelectionType.  Used on clientside to limit maximum selections.
     * @type {number}
     * @memberof CalendarProductDto
     */
    maxSelected: number;
    /**
     * Minimum \"recommended\" selections made by user, whether this means days or months depends on SelectionType.  Minimum value is dislayed but not enforced on clientside.
     * @type {number}
     * @memberof CalendarProductDto
     */
    minSelected: number;
    /**
     * Current amount of selections for clarity.  This should match the amount of days/months user has selected based on SelectionType
     * @type {number}
     * @memberof CalendarProductDto
     */
    currentSelected: number;
    /**
     * List of Day by day information relating to returned product
     * @type {Array<CalendarProductDayDto>}
     * @memberof CalendarProductDto
     */
    days: Array<CalendarProductDayDto>;
    /**
     * List of Day by day information relating to returned product
     * @type {Array<number>}
     * @memberof CalendarProductDto
     */
    availableYears: Array<number>;
}
/**
 * 
 * @export
 * @interface ChangedCalendarProductDayDto
 */
export interface ChangedCalendarProductDayDto {
    /**
     * 
     * @type {number}
     * @memberof ChangedCalendarProductDayDto
     */
    id?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ChangedCalendarProductDayDto
     */
    isSelected?: boolean;
}
/**
 * 
 * @export
 * @interface LegacyLoginDto
 */
export interface LegacyLoginDto {
    /**
     * 
     * @type {string}
     * @memberof LegacyLoginDto
     */
    xml?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LegacyLoginDto
     */
    url?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum OperationEnum {
    NUMBER_0 = 0,
    NUMBER_1 = 1,
    NUMBER_2 = 2,
    NUMBER_3 = 3,
    NUMBER_4 = 4
}

/**
 * 
 * @export
 * @interface Order
 */
export interface Order {
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    address?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Order
     */
    orderId?: number;
    /**
     * 
     * @type {number}
     * @memberof Order
     */
    orderRowId?: number;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    productName?: string | null;
}
/**
 * 
 * @export
 * @interface PostChangedCalendarProductDaysCommand
 */
export interface PostChangedCalendarProductDaysCommand {
    /**
     * 
     * @type {number}
     * @memberof PostChangedCalendarProductDaysCommand
     */
    orderRowId?: number;
    /**
     * 
     * @type {number}
     * @memberof PostChangedCalendarProductDaysCommand
     */
    orderId?: number;
    /**
     * 
     * @type {number}
     * @memberof PostChangedCalendarProductDaysCommand
     */
    year?: number;
    /**
     * 
     * @type {Array<ChangedCalendarProductDayDto>}
     * @memberof PostChangedCalendarProductDaysCommand
     */
    days?: Array<ChangedCalendarProductDayDto> | null;
}
/**
 * 
 * @export
 * @interface SaveNewPasswordCommand
 */
export interface SaveNewPasswordCommand {
    /**
     * 
     * @type {string}
     * @memberof SaveNewPasswordCommand
     */
    oldPassword: string;
    /**
     * 
     * @type {string}
     * @memberof SaveNewPasswordCommand
     */
    newPassword: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum SelectionTypeEnum {
    NUMBER_0 = 0,
    NUMBER_1 = 1
}

/**
 * 
 * @export
 * @interface SelfcareCustomerDto
 */
export interface SelfcareCustomerDto {
    /**
     * 
     * @type {number}
     * @memberof SelfcareCustomerDto
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof SelfcareCustomerDto
     */
    userName: string;
    /**
     * 
     * @type {Array<OperationEnum>}
     * @memberof SelfcareCustomerDto
     */
    services: Array<OperationEnum>;
}

/**
 * CalendarApi - axios parameter creator
 * @export
 */
export const CalendarApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get singular calender product for given year
         * @param {number} year Kuluva tai seuraava vuosi, määrää kumman kalenteri haetaan
         * @param {number} orderId 
         * @param {number} orderRowId 
         * @param {number} languageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerCalendarProduct: async (year: number, orderId: number, orderRowId: number, languageId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'year' is not null or undefined
            if (year === null || year === undefined) {
                throw new RequiredError('year','Required parameter year was null or undefined when calling getCustomerCalendarProduct.');
            }
            // verify required parameter 'orderId' is not null or undefined
            if (orderId === null || orderId === undefined) {
                throw new RequiredError('orderId','Required parameter orderId was null or undefined when calling getCustomerCalendarProduct.');
            }
            // verify required parameter 'orderRowId' is not null or undefined
            if (orderRowId === null || orderRowId === undefined) {
                throw new RequiredError('orderRowId','Required parameter orderRowId was null or undefined when calling getCustomerCalendarProduct.');
            }
            // verify required parameter 'languageId' is not null or undefined
            if (languageId === null || languageId === undefined) {
                throw new RequiredError('languageId','Required parameter languageId was null or undefined when calling getCustomerCalendarProduct.');
            }
            const localVarPath = `/selfcare/api/v1/calendarproducts/{Year}`
                .replace(`{${"Year"}}`, encodeURIComponent(String(year)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (orderId !== undefined) {
                localVarQueryParameter['OrderId'] = orderId;
            }

            if (orderRowId !== undefined) {
                localVarQueryParameter['OrderRowId'] = orderRowId;
            }

            if (languageId !== undefined) {
                localVarQueryParameter['LanguageId'] = languageId;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all customer\'s calender products, includes only minimal data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerCalendarProducts: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/selfcare/api/v1/calendarproducts`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Post Calender product days with changed values
         * @param {PostChangedCalendarProductDaysCommand} [postChangedCalendarProductDaysCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postChangedCalenderProductDays: async (postChangedCalendarProductDaysCommand?: PostChangedCalendarProductDaysCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/selfcare/api/v1/calendarproducts`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof postChangedCalendarProductDaysCommand !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(postChangedCalendarProductDaysCommand !== undefined ? postChangedCalendarProductDaysCommand : {}) : (postChangedCalendarProductDaysCommand || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CalendarApi - functional programming interface
 * @export
 */
export const CalendarApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get singular calender product for given year
         * @param {number} year Kuluva tai seuraava vuosi, määrää kumman kalenteri haetaan
         * @param {number} orderId 
         * @param {number} orderRowId 
         * @param {number} languageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerCalendarProduct(year: number, orderId: number, orderRowId: number, languageId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalendarProductDto>> {
            const localVarAxiosArgs = await CalendarApiAxiosParamCreator(configuration).getCustomerCalendarProduct(year, orderId, orderRowId, languageId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get all customer\'s calender products, includes only minimal data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerCalendarProducts(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Order>>> {
            const localVarAxiosArgs = await CalendarApiAxiosParamCreator(configuration).getCustomerCalendarProducts(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Post Calender product days with changed values
         * @param {PostChangedCalendarProductDaysCommand} [postChangedCalendarProductDaysCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postChangedCalenderProductDays(postChangedCalendarProductDaysCommand?: PostChangedCalendarProductDaysCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await CalendarApiAxiosParamCreator(configuration).postChangedCalenderProductDays(postChangedCalendarProductDaysCommand, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CalendarApi - factory interface
 * @export
 */
export const CalendarApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get singular calender product for given year
         * @param {number} year Kuluva tai seuraava vuosi, määrää kumman kalenteri haetaan
         * @param {number} orderId 
         * @param {number} orderRowId 
         * @param {number} languageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerCalendarProduct(year: number, orderId: number, orderRowId: number, languageId: number, options?: any): AxiosPromise<CalendarProductDto> {
            return CalendarApiFp(configuration).getCustomerCalendarProduct(year, orderId, orderRowId, languageId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all customer\'s calender products, includes only minimal data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerCalendarProducts(options?: any): AxiosPromise<Array<Order>> {
            return CalendarApiFp(configuration).getCustomerCalendarProducts(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Post Calender product days with changed values
         * @param {PostChangedCalendarProductDaysCommand} [postChangedCalendarProductDaysCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postChangedCalenderProductDays(postChangedCalendarProductDaysCommand?: PostChangedCalendarProductDaysCommand, options?: any): AxiosPromise<boolean> {
            return CalendarApiFp(configuration).postChangedCalenderProductDays(postChangedCalendarProductDaysCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CalendarApi - object-oriented interface
 * @export
 * @class CalendarApi
 * @extends {BaseAPI}
 */
export class CalendarApi extends BaseAPI {
    /**
     * 
     * @summary Get singular calender product for given year
     * @param {number} year Kuluva tai seuraava vuosi, määrää kumman kalenteri haetaan
     * @param {number} orderId 
     * @param {number} orderRowId 
     * @param {number} languageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public getCustomerCalendarProduct(year: number, orderId: number, orderRowId: number, languageId: number, options?: any) {
        return CalendarApiFp(this.configuration).getCustomerCalendarProduct(year, orderId, orderRowId, languageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all customer\'s calender products, includes only minimal data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public getCustomerCalendarProducts(options?: any) {
        return CalendarApiFp(this.configuration).getCustomerCalendarProducts(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Post Calender product days with changed values
     * @param {PostChangedCalendarProductDaysCommand} [postChangedCalendarProductDaysCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public postChangedCalenderProductDays(postChangedCalendarProductDaysCommand?: PostChangedCalendarProductDaysCommand, options?: any) {
        return CalendarApiFp(this.configuration).postChangedCalenderProductDays(postChangedCalendarProductDaysCommand, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * SelfcareCustomerApi - axios parameter creator
 * @export
 */
export const SelfcareCustomerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Selfcare Services for resource owner, return user info and enum list of services
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSelfcareCustomerServices: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/selfcare/api/v1/selfcareCustomer/services`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Change password handling
         * @param {SaveNewPasswordCommand} [saveNewPasswordCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveNewPassword: async (saveNewPasswordCommand?: SaveNewPasswordCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/selfcare/api/v1/selfcareCustomer/changepassword`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof saveNewPasswordCommand !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(saveNewPasswordCommand !== undefined ? saveNewPasswordCommand : {}) : (saveNewPasswordCommand || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Handle sign in to legacy application
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signInToLegacyApplication: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/selfcare/api/v1/selfcareCustomer/loginToLegacyApp`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SelfcareCustomerApi - functional programming interface
 * @export
 */
export const SelfcareCustomerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Selfcare Services for resource owner, return user info and enum list of services
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSelfcareCustomerServices(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SelfcareCustomerDto>> {
            const localVarAxiosArgs = await SelfcareCustomerApiAxiosParamCreator(configuration).getSelfcareCustomerServices(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Change password handling
         * @param {SaveNewPasswordCommand} [saveNewPasswordCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveNewPassword(saveNewPasswordCommand?: SaveNewPasswordCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await SelfcareCustomerApiAxiosParamCreator(configuration).saveNewPassword(saveNewPasswordCommand, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Handle sign in to legacy application
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signInToLegacyApplication(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LegacyLoginDto>> {
            const localVarAxiosArgs = await SelfcareCustomerApiAxiosParamCreator(configuration).signInToLegacyApplication(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * SelfcareCustomerApi - factory interface
 * @export
 */
export const SelfcareCustomerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get Selfcare Services for resource owner, return user info and enum list of services
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSelfcareCustomerServices(options?: any): AxiosPromise<SelfcareCustomerDto> {
            return SelfcareCustomerApiFp(configuration).getSelfcareCustomerServices(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Change password handling
         * @param {SaveNewPasswordCommand} [saveNewPasswordCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveNewPassword(saveNewPasswordCommand?: SaveNewPasswordCommand, options?: any): AxiosPromise<boolean> {
            return SelfcareCustomerApiFp(configuration).saveNewPassword(saveNewPasswordCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Handle sign in to legacy application
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signInToLegacyApplication(options?: any): AxiosPromise<LegacyLoginDto> {
            return SelfcareCustomerApiFp(configuration).signInToLegacyApplication(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SelfcareCustomerApi - object-oriented interface
 * @export
 * @class SelfcareCustomerApi
 * @extends {BaseAPI}
 */
export class SelfcareCustomerApi extends BaseAPI {
    /**
     * 
     * @summary Get Selfcare Services for resource owner, return user info and enum list of services
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SelfcareCustomerApi
     */
    public getSelfcareCustomerServices(options?: any) {
        return SelfcareCustomerApiFp(this.configuration).getSelfcareCustomerServices(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Change password handling
     * @param {SaveNewPasswordCommand} [saveNewPasswordCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SelfcareCustomerApi
     */
    public saveNewPassword(saveNewPasswordCommand?: SaveNewPasswordCommand, options?: any) {
        return SelfcareCustomerApiFp(this.configuration).saveNewPassword(saveNewPasswordCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Handle sign in to legacy application
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SelfcareCustomerApi
     */
    public signInToLegacyApplication(options?: any) {
        return SelfcareCustomerApiFp(this.configuration).signInToLegacyApplication(options).then((request) => request(this.axios, this.basePath));
    }

}


